<app-filterbutton *ngFor="let f of this.filters"
                  [currentFilter]="this.service.currentFilter"
                  [filterOption]='f.type'
                  (click)="setfilter(f.type)"
                  [bootstrapStyle]=f.styleClass>{{f.name}} {{this.service.countFilter(f.type)}}
</app-filterbutton>
